import s from './EventWizardModal.module.scss';

interface AiGeneratingProps {
  hint?: string;
  lines?: number;
}

export function AiGenerating({ hint, lines = 3 }: AiGeneratingProps) {
  return (
    <div className={s.aiGenerating} role="status" aria-live="polite">
      <div className={s.aiGeneratingHead}>
        <span className={s.aiGeneratingSparkle}>✨</span>
        <span className={s.aiGeneratingText}>
          Personalizing for you
          <span className={s.aiGeneratingDots}>
            <span />
            <span />
            <span />
          </span>
        </span>
      </div>
      {hint && <span className={s.aiGeneratingHint}>{hint}</span>}
      {lines > 0 && (
        <div className={s.aiGeneratingSkeleton}>
          {Array.from({ length: lines }, (_, i) => (
            <span key={i} className={s.aiGeneratingSkeletonLine} />
          ))}
        </div>
      )}
    </div>
  );
}
